module.exports = __webpack_public_path__ + "static/media/efix_CMYK.09cbf851.png";